import {YesNoFormValue, type KilnCheckSheetKilnSectionFormValues} from '../../../types'

export const kilnSectionDefaultValues: KilnCheckSheetKilnSectionFormValues = {
  slippageCreepChecks1st: '',
  slippageCreepChecks2nd: '',
  slippageCreepChecks3rd: '',
  slippageCreepChecks1stRetake: '',
  slippageCreepChecks2ndRetake: '',
  slippageCreepChecks3rdRetake: '',
  slippageCreepChecksComment: '',
  kilnBearingsOilLevelLevelsOk: {value: YesNoFormValue.YES, comment: ''},
  kilnBearingsCoolingWaterFlowSufficientFlow: {value: YesNoFormValue.YES, comment: ''},
  kilnThrustRollerOilLevelLevelsOk: {value: YesNoFormValue.YES, comment: ''},
  kilnThrustRollerKilnPositionOnThrust: '',
  kilnThrustRollerKilnPositionFloating: '',
  kilnThrustRollerKilnPositionUphill: '',
  kilnThrustRollerKilnPositionComment: '',
  kilnFeedEndSealPlatesBoltsCablesNormal: '',
  kilnFeedEndSealPlatesBoltsCablesDeficiency: '',
  kilnFeedEndSealPlatesBoltsCablesComment: '',
  kilnFeedEndSealMaterialLeak: {value: YesNoFormValue.YES, comment: ''},
  kilnDischargeSealPlatesCablesShroudNormal: '',
  kilnDischargeSealPlatesCablesShroudDamaged: '',
  kilnDischargeSealPlatesCablesShroudComment: '',
  kilnDischargeSealMaterialLeakExcessiveSpillage: {value: YesNoFormValue.YES, comment: ''},
  noseRingNoseCastingsNormal: '',
  noseRingNoseCastingsDamaged: '',
  noseRingNoseCastingsComment: '',
  noseRingNoseRingFansOperatingProperly: {value: YesNoFormValue.YES, comment: ''},
  noseRingFansGreased3ShotsOfGrease: {value: YesNoFormValue.YES, comment: ''},
  shellFansBeltsBearingsMotorOperatingProperly: {value: YesNoFormValue.YES, comment: ''}
}
